import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import HubHero from './components/HubHero';
import HubPillars from './components/HubPillars';
import HubNetwork from './components/HubNetwork';
import HubCta from './components/HubCta';
import {
  HUB_PAGE_TITLE,
  HUB_PAGE_DESCRIPTION,
} from './mediaLabHubContent';
import { CherryDevTheme } from '../CherrySoftware/CherryDevTheme';
import { CHERRY_DEV } from '../CherrySoftware/cherryDevBrand';
import { CHERRY_SOFTWARE_CONTAINER_PROPS } from '../CherrySoftware/cherrySoftwareLayout';

const LandingMediaLabHomeInner = () => {
  useEffect(() => {
    document.title = HUB_PAGE_TITLE;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', HUB_PAGE_DESCRIPTION);
  }, []);

  return (
    <Box
      sx={{
        bgcolor: CHERRY_DEV.cream,
        fontFamily: '"Outfit", "Segoe UI", system-ui, sans-serif',
      }}
    >
      <HubHero />

      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <HubPillars />
      </Container>

      <Box bgcolor={CHERRY_DEV.blush}>
        <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
          <HubNetwork />
        </Container>
      </Box>

      <Container {...CHERRY_SOFTWARE_CONTAINER_PROPS}>
        <HubCta />
      </Container>
    </Box>
  );
};

const LandingMediaLabHome = () => (
  <CherryDevTheme>
    <LandingMediaLabHomeInner />
  </CherryDevTheme>
);

LandingMediaLabHome.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaLabHome;
